<template>
  <v-select
    v-model="selected"
    placeholder="Select a rota..."
    :options="options"
    :filterable="false"
    :searchable="false"
    :loading="loading"
    :clearable="false"
    :selectable="(option) => !option.disabled"
    :get-option-label="label"
  />
</template>

<script>
import { computed } from "vue";
import vSelect from "vue-select";
import { formatRotaStartDateShort } from "@/lib/date-functions";

function label(option) {
  if (option.label) {
    return option.label;
  }
  let text = `${option.location.toUpperCase()} (${option.type})`;
  if (option.name) {
    text = `${option.name}: ${text}`;
  }
  text += ` ${formatRotaStartDateShort(
    option.startDate,
  )} - ${formatRotaStartDateShort(option.endDate)}`;
  return text;
}

export default {
  components: {
    vSelect,
  },
  props: {
    options: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      required: true,
    },
    modelValue: {
      type: Object,
      default: null,
    },
  },
  emits: ["update:modelValue"],
  setup(props, { emit }) {
    const selected = computed({
      get() {
        return props.modelValue;
      },
      set(value) {
        emit("update:modelValue", value);
      },
    });

    return {
      label,
      selected,
    };
  },
};
</script>

<style lang="scss">
#rota-select {
  .vs__selected-options {
    overflow-x: hidden;
    flex-wrap: nowrap;
  }

  .vs__selected {
    white-space: nowrap;
  }
}
</style>
